type Options = { [key: string]: string | number };

const instance = new Map();

export default (options?: Options) => {
  if (options) Object.entries(options).forEach(([key, value]) => instance.set(key, value));

  return instance;
};
